import React from "react";
import { connect } from "react-redux";
import { Layout, Row, Col, Card, Input, Select, Space, Spin, Alert, Button, Flex, Typography, Modal, Tooltip } from 'antd';
import { InputCurrency, SwitchLabel, InputMask, FormAddress, AutoCompleteCompany, Form, InputNumber, Header, BoxColor } from "components";
import { COMPANY_TYPE_DATA, BUSINESS_TYPE_DATA, ANNUAL_REVENUE_RANGE_DATA } from "utils/static-data";
import { getCompany, getCompanyBenefits, getCompanyKycStatus, saveCompany } from "services/company-service";
import { useNavigate, useParams } from 'react-router-dom';
import { SaveOutlined, InfoCircleOutlined } from '@ant-design/icons';
import moment from "moment";
import CompanyShareholderScreen from './company-shareholder-screen';
import { submitForm } from 'utils';
import { DatePicker } from "components";
import { getAllBenefit } from "services/benefit-service";

const { Content, Footer } = Layout;

const mapStateToProps = (state) => ({
    login: state.authReducer.loginReducer,
    config: state.configReducer,
});

const CompanyDetailsScreen = React.forwardRef((props, ref) => {
    const { compact = false, company = null, onAfterSubmit, login, config } = props;
    const navigate = useNavigate();
    const { id = company } = useParams();
    const [form] = Form.useForm();
    const wtCompanyType = Form.useWatch(["companyType", "code"], form);
    const [data, setData] = React.useState(null);
    const [benefits, setBenefits] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [openFantasyName, setOpenFantasyName] = React.useState(false);
    const [companyType, setCompanyType] = React.useState("C");
    const [acceptBillUtility, setAcceptBillUtility] = React.useState(false);
    const [acceptBillGeneric, setAcceptBillGeneric] = React.useState(false);
    const [appMain, setAppMain] = React.useState(true);
    const [whitelabel, setWhitelabel] = React.useState(false);
    const [acceptTed, setAcceptTed] = React.useState(false);
    const [acceptPix, setAcceptPix] = React.useState(false);
    const [acceptRewardVouchers, setAcceptRewardVouchers] = React.useState(false);
    const [rewardBreakage, setRewardBreakage] = React.useState(null);
    const [acceptUserFundsIn, setAcceptUserFundsIn] = React.useState(false);
    const MAX_LIMIT = 249999.98;
    const MAX_BILL_UTILITY_LIMIT = 500000;
    const MAX_BILL_GENERIC_LIMIT = 1400000;
    const [foundedAt, setFoundedAt] = React.useState(null);
    const [alerts, setAlerts] = React.useState([]);
    const DEFAULT_TRANSFER_LIMIT = 5000;
    const DEFAULT_TRANSFER_NIGHT_LIMIT = 1000;
    const DEFAULT_PIX_COMPANY_DAY_LIMIT = 500000;
    const DEFAULT_PIX_COMPANY_NIGHT_LIMIT = 100000;
    const DEFAULT_CORPORATE_PIX_DAY_LIMIT = 5000;
    const DEFAULT_CORPORATE_PIX_NIGHT_LIMIT = 1000;
    const DEFAULT_CORPORATE_DAILY_PIX_LIMIT = 5000;
    const DEFAULT_SCHEDULE_COMPANY_MIN_LIMIT = 0.5;
    const DEFAULT_SCHEDULE_COMPANY_MAX_LIMIT = 100000;
    const [pixDailyTransferLimit, setPixDailyTransferLimit] = React.useState(DEFAULT_TRANSFER_LIMIT);
    const [pixDayLimitValue, setPixDayLimitValue] = React.useState(DEFAULT_TRANSFER_LIMIT);
    const [pixCompanyDayLimit, setPixCompanyDayLimit] = React.useState(DEFAULT_PIX_COMPANY_DAY_LIMIT);
    const [pixCompanyNightLimit, setPixCompanyNightLimit] = React.useState(DEFAULT_PIX_COMPANY_NIGHT_LIMIT);
    const [corporatePixDayLimit, setCorporatePixDayLimit] = React.useState(DEFAULT_CORPORATE_PIX_DAY_LIMIT);
    const [corporatePixNightLimit, setCorporatePixNightLimit] = React.useState(DEFAULT_CORPORATE_PIX_NIGHT_LIMIT);
    const [corporateDailyPixLimit, setCorporateDailyPixLimit] = React.useState(DEFAULT_CORPORATE_DAILY_PIX_LIMIT);
    const [minScheduleValue, setMinScheduleValue] = React.useState(DEFAULT_PIX_COMPANY_DAY_LIMIT);
    const [maxScheduleValue, setMaxScheduleValue] = React.useState(DEFAULT_PIX_COMPANY_NIGHT_LIMIT);
    const [schedule, setSchedule] = React.useState(true);
    const [marketplace, setMarketplace] = React.useState(false);
    const foodPrepaid = Form.useWatch("foodPrepaid", form) ?? false;
    const [pixMobility, setPixMobility] = React.useState(false);
    const [corporateCard, setCorporateCard] = React.useState(false);
    const [corporatePix, setCorporatePix] = React.useState(false);
    const [corporateTed, setCorporateTed] = React.useState(false);
    const [acceptCorporateBill, setAcceptCorporateBill] = React.useState(false);
    const [acceptCorporateBillGeneric, setAcceptCorporateBillGeneric] = React.useState(false);
    const [corporateDailyBillPaymentLimit, setCorporateDailyBillPaymentLimit] = React.useState(DEFAULT_TRANSFER_LIMIT);
    const [corporateDailyBillGenericPaymentLimit, setCorporateDailyBillGenericPaymentLimit] = React.useState(DEFAULT_TRANSFER_LIMIT);
    const [corporatePixFee, setCorporatePixFee] = React.useState(0);
    const [corporateTedFee, setCorporateTedFee] = React.useState(0);
    const [corporateBillFeeUtility, setCorporateBillFeeUtility] = React.useState(0);
    const [corporateBillFeeGeneric, setCorporateBillFeeGeneric] = React.useState(0);
    const [corporateChargeFee, setCorporateChargeFee] = React.useState(0);
    const [corporatePartChargeFee, setCorporatePartChargeFee] = React.useState(0);
    const [corporateFundsIn, setCorporateFundsIn] = React.useState(false);
    const [allowShareholderOperation, setAllowShareholderOperation] = React.useState(false);

    const handleDateChange = (date, dateString) => {
        setFoundedAt(date);
    };

    const load = async () => {
        try {
            loadBenefits(id);
            if (id && !data) {
                setLoading(true);
                const res = await getCompany(id);
                if (res) {
                    setPixDailyTransferLimit(res.dailyPixLimit || DEFAULT_TRANSFER_LIMIT);
                    setPixDayLimitValue(res.pixDayLimit || DEFAULT_TRANSFER_LIMIT);
                    const kycStatus = await getCompanyKycStatus(id);
                    setData({
                        ...res,
                        dailyTedLimit: res.dailyTedLimit || DEFAULT_TRANSFER_LIMIT,
                        dailyPixLimit: res.dailyPixLimit || DEFAULT_TRANSFER_LIMIT,
                        pixCompanyDayLimit: res.pixCompanyDayLimit || DEFAULT_PIX_COMPANY_DAY_LIMIT,
                        pixCompanyNightLimit: res.pixCompanyNightLimit || DEFAULT_PIX_COMPANY_NIGHT_LIMIT,
                        corporatePixDayLimit: res.corporatePixDayLimit || DEFAULT_CORPORATE_PIX_DAY_LIMIT,
                        corporatePixNightLimit: res.corporatePixNightLimit || DEFAULT_CORPORATE_PIX_NIGHT_LIMIT,
                        corporateDailyPixLimit: res.corporateDailyPixLimit || DEFAULT_CORPORATE_DAILY_PIX_LIMIT,
                        pixDayLimit: res.pixDayLimit || DEFAULT_TRANSFER_LIMIT,
                        pixNightLimit: res.pixNightLimit || DEFAULT_TRANSFER_LIMIT,
                        dailyBillUtilityPaymentLimit: res.dailyBillUtilityPaymentLimit || DEFAULT_TRANSFER_LIMIT,
                        dailyBillGenericPaymentLimit: res.dailyBillGenericPaymentLimit || DEFAULT_TRANSFER_LIMIT,
                        kycStatus: kycStatus ? kycStatus.status : null,
                        kycErrors: kycStatus ? kycStatus.kycErrors : [],
                        biometricErrors: kycStatus? kycStatus.biometricErrors: [],
                        isFoodPrepaid: res.foodPrepaid,
                        pixMobility: res.pixMobility,
                        allowShareholderOperation: res.allowShareholderOperation,
                    });
                    setAcceptBillUtility(res.acceptBillUtility);
                    setAcceptBillGeneric(res.acceptBillGeneric);
                    setAcceptTed(res.acceptTed);
                    setAcceptPix(res.acceptPix);
                    setAcceptRewardVouchers(res.acceptRewardVouchers);
                    setRewardBreakage(res.rewardBreakage);
                    setAcceptUserFundsIn(res.acceptUserFundsIn);
                    setAppMain(res.appMain);
                    setWhitelabel(res.whitelabel);
                    setPixMobility(res.pixMobility);
                    setAllowShareholderOperation(res.allowShareholderOperation);
                    setSchedule(res.schedule);
                    setMarketplace(res.marketplace);
                    setCorporateCard(res.corporateCard ?? false);
                    setCorporatePix(res.corporatePix ?? false);
                    setCorporateTed(res.corporateTed ?? false);
                    setAcceptCorporateBill(res.acceptCorporateBill ?? false);
                    setAcceptCorporateBillGeneric(res.acceptCorporateBillGeneric ?? false);
                    setCorporateDailyBillPaymentLimit(res.corporateDailyBillPaymentLimit || DEFAULT_TRANSFER_LIMIT);
                    setCorporateDailyBillGenericPaymentLimit(res.corporateDailyBillGenericPaymentLimit || DEFAULT_TRANSFER_LIMIT);
                    setCorporatePixFee(res.corporatePixFee ?? 0);
                    setCorporateTedFee(res.corporateTedFee ?? 0);
                    setCorporateBillFeeUtility(res.corporateBillFeeUtility ?? 0);
                    setCorporateBillFeeGeneric(res.corporateBillFeeGeneric ?? 0);
                    setCorporateChargeFee(res.corporateChargeFee ?? 0);
                    setCorporatePartChargeFee(res.corporatePartChargeFee ?? 0);
                    setCorporateFundsIn(res.corporateFundsIn ?? false);
                    setCorporatePixDayLimit(res.corporatePixDayLimit || DEFAULT_CORPORATE_PIX_DAY_LIMIT);
                    setCorporatePixNightLimit(res.corporatePixNightLimit || DEFAULT_CORPORATE_PIX_NIGHT_LIMIT);
                    setCorporateDailyPixLimit(res.corporateDailyPixLimit || DEFAULT_CORPORATE_DAILY_PIX_LIMIT);
                }
            }

        } finally {
            setLoading(false);
        }
    }

    const loadBenefits = async (id) => {
        if (id) {
            setBenefits(await getAllBenefit(id));
        } else {
            setBenefits(await getCompanyBenefits(true));
        }
    }

    const handleBenefit = (index, value) => {
        setBenefits(prev => {
            const next = [...prev];
            next[index] = { ...next[index], enabled: value };
            return next;
        });
    }

    const formatCurrency = (amount) => {

        const formattedAmount = amount.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });

        return formattedAmount;
    }

    const formatPhoneNumber = (phoneNumber) => {
        const cleaned = phoneNumber.startsWith('55') ? phoneNumber.slice(2) : phoneNumber;
        const onlyNumbers = cleaned.replace(/\D/g, '');
        const match = onlyNumbers.match(/^(\d{2})(\d{5})(\d{4})$/);
        if (match) {
            return `(${match[1]}) ${match[2]}-${match[3]}`;
        }
        return phoneNumber;
    };

    const loadFieldsCompany = () => {

        const formattedPhone = data.phone
            ? formatPhoneNumber(data.phone.startsWith("55") ? data.phone.substring(2) : data.phone)
            : null;

        form.setFieldsValue({
            ...data,
            foundedAt: data.foundedAt ? moment(data.foundedAt) : undefined,
            firstContractAt: data.firstContractAt ? moment(data.firstContractAt) : undefined,
            phone: formattedPhone,

        });
        setOpenFantasyName(data.hasNickName);
    }

    const onSave = async (values) => {
        setLoading(true);
        try {
            values.fantasyName = values.name;
            data?.bankAccount?.account?.numberWithDigit && delete data.bankAccount.account.numberWithDigit;
            data?.bankAccount?.branch?.numberWithDigit && delete data.bankAccount.branch.numberWithDigit;
            data?.kycStatus && delete data.kycStatus;
            data?.kycUpdatedStatusAt && delete data.kycUpdatedStatusAt
            const response = await saveCompany(id, { ...data, ...values, segmentations: benefits });
            if (onAfterSubmit) {
                onAfterSubmit(true);
            } else {
                if (response.success) {
                    if (response.data.id) {
                        navigate(`/company/${response.data.id}`);
                    } else {
                        navigate(`/company`);
                    }
                }
            }
        } catch (e) {
            console.log(e)
        } finally {
            setLoading(false);
        }
    }

    const onFinishFailed = () => {
        if (onAfterSubmit) {
            onAfterSubmit();
        }
    }

    const loadAlerts = () => {
        const newAlerts = [];

        if (data && data.kycErrors.length > 0) {
            Array.from(data.kycErrors).forEach(error => {
                newAlerts.push({
                    message: error,
                    type: "error",
                })
            })
        }
        
        if (data && data.biometricErrors.length > 0) {
            Array.from(data.biometricErrors).forEach(error => {
                newAlerts.push({
                    message: error,
                    type: "error",
                })
            })
        }

        setAlerts(newAlerts);

    }

    const createKycStatus = () => {
        if (data) {
            const kycStatus = data.kycStatus;
            if (kycStatus) {
                return (
                    <Row align="middle" style={{ marginBottom: 10 }}>
                        <Col span={24}>
                            <Alert message={`Validação de Dados: ${kycStatus.name}`} type={kycStatus.category} showIcon />
                        </Col>
                    </Row>
                )
            }
        }
        return null
    }

    const loadSubRoutes = React.useMemo(() => {
        // if (id && data && login.company.master) {
        //     const routes = [
        //         { label: "Vantagens", route: `/company/${id}/advantages`, state: { company: data } }
        //     ]
        //
        //     return routes
        // }
        return [];
    }, [id, data, login]);

    React.useImperativeHandle(ref, () => {
        return {
            async submit() {
                return await submitForm(form);
            }
        };
    });

    React.useEffect(() => {
        if (data) {
            loadFieldsCompany()
            loadAlerts()
        }
    }, [data]);

    React.useEffect(() => {
        load();
    }, [id])

    const handleCNPJChange = (event) => {
        const { value } = event.target;
        const cleanedValue = value.replace(/_/g, '');
        const isValidFormat = /^(\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}|\d{14})$/.test(cleanedValue);
        if (isValidFormat) {
            form.setFieldsValue({ cnpj: cleanedValue });
        } else {
            form.setFieldsValue({ cnpj: cleanedValue.slice(0, 18) });
        }
    }

    const handleAppMainChange = (checked) => {
        if (!checked) {
            Modal.confirm({
                title: 'Tem certeza que deseja desabilitar o app?',
                content: 'Ao desabilitar os App, nenhum usuário cadastrado nessa empresa conseguirá acessar os Aplicativos da AlyPlus.',
                okText: 'Sim',
                cancelText: 'Não',
                onOk() {
                    setAppMain(false);
                    form.setFieldsValue({ appMain: false });
                },
                onCancel() {
                    form.setFieldsValue({ appMain: true });
                },
            });
        } else {
            setAppMain(true);
        }
    };

    const handleFood = (checked, type) => {
        const isFoodPostpaid = type === 'postpaid' ? checked: !checked;
        const isFoodPrepaid = type === 'prepaid' ? checked: !checked;
        form.setFieldsValue({ foodPostpaid: isFoodPostpaid, foodPrepaid: isFoodPrepaid });
    };

    const ContentForm = (
        <>
            <Col gutter={16} style={{ marginBottom: 30 }}>
                {alerts.map((a) => (
                    <Col xl={12} lg={18} md={24} sm={24} style={{ margin: '0 auto 15px' }}>
                        <Alert showIcon message={a.message} type={a.type} />
                    </Col>
                ))}
            </Col>
            <Row justify="center">
                <Col xl={12} lg={18} md={24}>
                    <Form form={form} layout="vertical" name="basic" onFinish={onSave} onFinishFailed={onFinishFailed}>
                        <Space direction="vertical" size="large">
                            <Card title="Informações Básicas">
                                <Spin spinning={loading}>
                                    {createKycStatus()}
                                    <Form.Item
                                        label="Razão Social"
                                        hasFeedback
                                        name="corporateName"
                                        rules={[
                                            { required: true, message: "Insira uma razão social" },
                                            { max: 100, message: "Campo não deve exceder 100 caracteres" },
                                        ]}
                                    >
                                        <Input maxLength={100} autoComplete="off" />
                                    </Form.Item>
                                    <Form.Item noStyle>
                                        <Form.Item
                                            label="Nome Fantasia"
                                            hasFeedback
                                            name="name"
                                            rules={[
                                                { required: true, message: "Insira um nome fantasia" },
                                                { max: 100, message: "Campo não deve exceder 100 caracteres" },
                                            ]}
                                        >
                                            <Input
                                                maxLength={100}
                                                autoComplete="off"
                                            />
                                        </Form.Item>
                                    </Form.Item>
                                    {!compact &&
                                        <Form.Item
                                            hasFeedback
                                            label="Tipo"
                                            initialValue={"C"}
                                            name={["companyType", "code"]}
                                            rules={[{ required: true, message: "Insira um tipo" }]}
                                        >
                                            <Select onChange={(value => setCompanyType(value))} placeholder="Selecione um tipo">
                                                {COMPANY_TYPE_DATA.map(x => <Select.Option value={x.code}>{x.name}</Select.Option>)}
                                            </Select>
                                        </Form.Item>
                                    }
                                    <Form.Item
                                        label="CNPJ"
                                        hasFeedback
                                        name="cnpj"

                                        rules={[
                                            { required: true, message: "Insira um CNPJ válido" },
                                            {
                                                pattern: /^(\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}|\d{14})$/,
                                                message: "O formato do CNPJ está incorreto. Use o formato xx.xxx.xxx/xxxx-xx ou 14 dígitos consecutivos"
                                            }
                                        ]}
                                    >
                                        <InputMask
                                            onChange={handleCNPJChange}
                                            disabled={id ? true : false}
                                            mask="99.999.999/9999-99"
                                            placeholder="99.999.999/9999-99"
                                            autoComplete="off"
                                        >
                                            {(inputProps) => (
                                                <Input
                                                    maxLength={18}
                                                    {...inputProps}
                                                    autoComplete="off"
                                                />
                                            )}
                                        </InputMask>
                                    </Form.Item>
                                    {!compact &&
                                        <React.Fragment>
                                            {wtCompanyType !== "C" &&
                                                <Form.Item
                                                    label="Taxa"
                                                    name="fee"
                                                >
                                                    <InputNumber addonBefore="%" autoComplete="off" />
                                                </Form.Item>
                                            }
                                            <Form.Item
                                                label="Empresa Matriz"
                                                name={["matriz", "id"]}>
                                                <AutoCompleteCompany />
                                            </Form.Item>
                                        </React.Fragment>
                                    }
                                    <Form.Item
                                        label="E-mail"
                                        name="email"
                                        hasFeedback
                                        rules={[
                                            {
                                                required: true,
                                                type: "email",
                                                message: "Insira um e-mail válido",
                                            },
                                            { max: 80, message: 'Campo não deve ultrapassar 80 caracteres' }

                                        ]}
                                    >
                                        <Input maxLength={80} autoComplete="off" type="email" />
                                    </Form.Item>
                                    <Form.Item
                                        label="Tipo de Negócio"
                                        name={["businessType", "code"]}>
                                        <Select placeholder="Selecione um tipo">
                                            {BUSINESS_TYPE_DATA.map(x => <Select.Option key={x.code} value={x.code}>{x.name}</Select.Option>)}
                                        </Select>
                                    </Form.Item>
                                    <Form.Item
                                        label="CNAE"
                                        name="cnae"
                                        rules={[
                                            {
                                                pattern: /^\d{2}\.\d{2}-\d-\d{2}$/,
                                                message: 'CNAE deve estar no formato 00.00-0-00',
                                            },
                                        ]}
                                    >
                                        <InputMask
                                            mask="99.99-9-99"
                                            placeholder="00.00-0-00"
                                            hasFeedback
                                            onChange={(event) => {
                                                const { value } = event.target;
                                                const cleanedValue = value.replace(/_/g, '');
                                                const isValidFormat = /^\d{2}\.\d{2}-\d-\d{2}$/.test(cleanedValue);
                                                if (isValidFormat) {
                                                    form.setFieldsValue({ cnae: cleanedValue });
                                                } else {
                                                    form.setFieldsValue({ cnae: cleanedValue.slice(0, 10) });
                                                }
                                            }}
                                        >
                                            {(inputProps) => (
                                                <Input
                                                    maxLength={10}
                                                    {...inputProps}
                                                    autoComplete="off"
                                                />
                                            )}
                                        </InputMask>
                                    </Form.Item>
                                    <Form.Item
                                        label="Data de Fundação"
                                        name="foundedAt"
                                        rules={[{ required: true, message: "Insira uma data de fundação" }]}
                                    >
                                        <DatePicker
                                            placeholder="DD/MM/AAAA"
                                            value={foundedAt ? moment(foundedAt, 'DD/MM/YYYY') : null}
                                            onChange={handleDateChange}
                                            disabledDate={(current) => {
                                                return current && current > moment().endOf('day');
                                            }}
                                            allowClear
                                            format="DD/MM/YYYY"
                                            style={{ width: "100%" }}
                                            inputReadOnly={false}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label="Telefone"
                                        hasFeedback
                                        rules={[
                                            { 
                                                pattern: /^\(\d{2}\) \d{5}-\d{4}$/,
                                                message: 'Verifique o número de telefone' }
                                        ]}
                                        name="phone"
                                    >
                                        <InputMask
                                            mask="(99) 99999-9999"
                                            placeholder="(00) 00000-0000"
                                            onChange={(event) => {
                                                const { value } = event.target;
                                                const cleanedValue = value.replace(/_/g, '');
                                                const isValidFormat = /^\(\d{2}\) \d{5}-\d{4}$/.test(cleanedValue);
                                                if (isValidFormat) {
                                                    form.setFieldsValue({ phone: cleanedValue });
                                                } else {
                                                    form.setFieldsValue({ phone: cleanedValue.slice(0, 15) });
                                                }
                                            }}
                                        >
                                            {(inputProps) => (
                                                <Input
                                                    {...inputProps}
                                                    addonBefore="+55"
                                                    autoComplete="off"
                                                />
                                            )}
                                        </InputMask>
                                    </Form.Item>
                                    <Form.Item
                                        label="Inscrição Municipal"
                                        name="im"
                                        rules={[
                                            { max: 15, message: 'Campo não deve ultrapassar 15 caracteres' }
                                        ]}
                                    >
                                        <Input maxLength={15} autoComplete="off" />
                                    </Form.Item>
                                    {!compact &&
                                        <React.Fragment>
                                            <Form.Item
                                                label="Sistema de Conta"
                                                initialValue="swap"
                                                name={["accountSystem", "code"]}
                                                rules={[{ required: true, message: "Insira um sistema de conta" }]}
                                            >
                                                <Select disabled={id ? true : false} placeholder="Selecione um sistema de conta" allowClear>
                                                    {config.system.map(x => <Select.Option value={x.code}>{x.name}</Select.Option>)}
                                                </Select>
                                            </Form.Item>
                                            <Form.Item
                                                label="Faixa de faturamento anual"
                                                name={["annualRevenueRange"]}
                                                rules={[{ required: true, message: "Selecione uma faixa de faturamento anual" }]}
                                            >
                                                <Select disabled={id && form.annualRevenueRange ? true : false} placeholder="Selecione uma faixa de faturamento anual" allowClear>
                                                    {ANNUAL_REVENUE_RANGE_DATA.map(x => <Select.Option value={x.code}>{x.name}</Select.Option>)}
                                                </Select>
                                            </Form.Item>
                                            <Flex justify="space-between">
                                                <Typography.Text
                                                    strong
                                                    style={{
                                                        fontSize: '16px'
                                                    }}>
                                                    Habilitar Código Usuário
                                                </Typography.Text>
                                                <Form.Item
                                                    name={"enableCode"}
                                                    initialValue={false}
                                                    valuePropName="checked"
                                                >
                                                    <SwitchLabel label="" />
                                                </Form.Item>
                                            </Flex >

                                            <Flex justify="space-between">
                                                <Typography.Text
                                                    strong
                                                    style={{
                                                        fontSize: '16px'
                                                    }}>
                                                    Transferência TED
                                                </Typography.Text>
                                                <Form.Item
                                                    name={"acceptTed"}
                                                    initialValue={acceptTed}
                                                    valuePropName="checked"
                                                >
                                                    <SwitchLabel onChange={(value) => setAcceptTed(value)} label="" />
                                                </Form.Item>
                                            </Flex >

                                            <Row gutter={24}>
                                                {acceptTed && <Col>
                                                    <Form.Item
                                                        label="Valor máximo diário de TED permitido por usuário"
                                                        initialValue={DEFAULT_TRANSFER_LIMIT}
                                                        name="dailyTedLimit"
                                                        rules={[
                                                            { min: 0, type: 'number', message: 'Valor deve ser maior ou igual a R$ 0,00' },
                                                            { max: MAX_LIMIT, type: 'number', message: `Valor não deve ultrapassar R$ ${formatCurrency(MAX_LIMIT)}` },
                                                        ]}
                                                    >
                                                        <InputCurrency autoComplete="off" />
                                                    </Form.Item>
                                                </Col>}
                                            </Row>

                                            <Flex justify="space-between">
                                                <Typography.Text
                                                    strong
                                                    style={{
                                                        fontSize: '16px'
                                                    }}>
                                                    Transferência PIX
                                                </Typography.Text>
                                                <Form.Item
                                                    name={"acceptPix"}
                                                    initialValue={acceptPix}
                                                    valuePropName="checked"
                                                >
                                                    <SwitchLabel onChange={(value) => setAcceptPix(value)} label="" />
                                                </Form.Item>
                                            </Flex >

                                            <Row gutter={24}>
                                                {acceptPix && <Col>
                                                    <Form.Item
                                                        label={<span>Valor máximo diário de PIX permitido por usuário <Tooltip title="Limite interno da Aly+. Define o valor máximo acumulado que um usuário pode transferir via PIX com sucesso durante o dia inteiro, independentemente do horário. Este é o valor exibido para o usuário no aplicativo como &quot;Limite disponível agora&quot;."><InfoCircleOutlined style={{ marginLeft: 5}} /></Tooltip></span>}
                                                        initialValue={DEFAULT_TRANSFER_LIMIT}
                                                        name="dailyPixLimit"
                                                        rules={[
                                                            { min: 0, type: 'number', message: 'Valor deve ser maior ou igual a R$ 0,00' },
                                                            { max: Number(pixDayLimitValue.toFixed(2)), type: 'number', message: 'Valor não deve exceder o limite diurno do Banco Central.' },
                                                        ]}
                                                    >
                                                        <InputCurrency onChange={(value) => setPixDailyTransferLimit(value)} autoComplete="off" />
                                                    </Form.Item>


                                                    <Form.Item
                                                        label={<span>Limite diurno (das 06:00 às 19:59)&nbsp;<Tooltip title="Limite regulatório do Banco Central para transferências PIX realizadas no período diurno (das 06h00 às 19h59). Alterações são propagadas para todos os usuários da empresa em até 24 horas."><InfoCircleOutlined style={{ marginLeft: 5}} /></Tooltip></span>}
                                                        initialValue={DEFAULT_TRANSFER_LIMIT}
                                                        name="pixDayLimit"
                                                        rules={[
                                                            { min: 0, type: 'number', message: 'Valor deve ser maior ou igual a R$ 0,00' },
                                                            { max: MAX_LIMIT, type: 'number', message: `Valor não deve ultrapassar R$ ${formatCurrency(MAX_LIMIT)}` },
                                                        ]}
                                                    >
                                                        <InputCurrency onChange={(value) => setPixDayLimitValue(value)} autoComplete="off" />
                                                    </Form.Item>


                                                    <Form.Item
                                                        label={<span>Limite noturno (das 20:00 às 05:59)&nbsp;<Tooltip title="Limite regulatório do Banco Central para transferências PIX realizadas no período noturno (das 20h00 às 05h59). Alterações são propagadas para todos os usuários da empresa em até 24 horas."><InfoCircleOutlined style={{ marginLeft: 5}} /></Tooltip></span>}
                                                        initialValue={DEFAULT_TRANSFER_NIGHT_LIMIT}
                                                        name="pixNightLimit"
                                                        rules={[
                                                            { min: 0, type: 'number', message: 'Valor deve ser maior ou igual a R$ 0,00' },
                                                            { max: MAX_LIMIT, type: 'number', message: `Valor não deve ultrapassar R$ ${formatCurrency(MAX_LIMIT)}` },
                                                        ]}
                                                    >
                                                        <InputCurrency autoComplete="off" />
                                                    </Form.Item>
                                                </Col>}
                                            </Row>

                                            <Flex justify="space-between">
                                                <Typography.Text
                                                    strong
                                                    style={{
                                                        fontSize: '16px'
                                                    }}>
                                                    Funds In Via APP
                                                </Typography.Text>
                                                <Form.Item
                                                    name={"acceptUserFundsIn"}
                                                    initialValue={acceptUserFundsIn}
                                                    valuePropName="checked"
                                                >
                                                    <SwitchLabel onChange={(value) => setAcceptUserFundsIn(value)} label="" />
                                                </Form.Item>
                                            </Flex >

                                            <Row gutter={24}>
                                                {acceptUserFundsIn && <Col>
                                                    <Form.Item
                                                        label="Val. Minimo Carga Pix - Usuario"
                                                        name="minUserFundsIn"
                                                        initialValue={50}
                                                    >
                                                        <InputCurrency autoComplete="off" />
                                                    </Form.Item>
                                                </Col>}
                                            </Row>

                                            <Flex justify="space-between" style={{ marginTop: "18px" }}>
                                                <Typography.Text strong style={{ fontSize: "16px" }}>
                                                    Alimentação
                                                </Typography.Text>

                                                <Form.Item name="foodPrepaid" initialValue={false} valuePropName="checked">
                                                    <SwitchLabel
                                                    onChange={(value) => handleFood(value, "prepaid")}
                                                    label=""
                                                    />
                                                </Form.Item>
                                            </Flex>

                                            <Flex justify="space-between">
                                                <Typography.Text strong style={{ fontSize: "16px" }}>
                                                    Alimentação (Crédito)
                                                </Typography.Text>

                                                <SwitchLabel
                                                    checked={!foodPrepaid}
                                                    onChange={(value) => {
                                                    form.setFieldsValue({ foodPrepaid: !value });
                                                    handleFood(value, "postpaid");
                                                    }}
                                                    label=""
                                                />
                                            </Flex>

                                            <Flex justify="space-between" style={{ marginTop: "18px" }}>
                                                <Typography.Text strong style={{ fontSize: "16px" }}>
                                                    Link+
                                                </Typography.Text>

                                                <Form.Item
                                                    name={"acceptRewardVouchers"}
                                                    initialValue={acceptRewardVouchers}
                                                    valuePropName="checked"
                                                >
                                                    <SwitchLabel onChange={(value) => setAcceptRewardVouchers(value)} label="" />
                                                </Form.Item>
                                            </Flex>

                                            <Row gutter={24}>
                                                {acceptRewardVouchers && <Col span={24}>
                                                    <Form.Item
                                                        label="Breakage"
                                                        name="rewardBreakage"
                                                        initialValue={rewardBreakage}
                                                        rules={[{ required: true, message: "Selecione o destino do breakage" }]}
                                                    >
                                                        <Select
                                                            onChange={(value) => setRewardBreakage(value)}
                                                            placeholder="Selecione o destino dos valores expirados"
                                                        >
                                                            <Select.Option value="COMPANY">Conta principal da empresa</Select.Option>
                                                            <Select.Option value="MASTER">Conta master Aly+</Select.Option>
                                                        </Select>
                                                    </Form.Item>
                                                </Col>}
                                            </Row>

                                            <Flex justify="space-between" style={{ marginTop: "18px" }}>
                                                <Typography.Text strong style={{ fontSize: '16px' }}>
                                                    Pix - Mobilidade
                                                </Typography.Text>
                                                <Form.Item
                                                    name={"pixMobility"}
                                                    initialValue={pixMobility}
                                                    valuePropName="checked"
                                                >
                                                    <SwitchLabel onChange={(value) => setPixMobility(value)} label="" />
                                                </Form.Item>
                                            </Flex >

                                            <Flex justify="space-between" style={{ marginTop: "18px" }}>
                                                <Typography.Text strong style={{ fontSize: '16px' }}>
                                                    Habilitada para operar com um sócio
                                                </Typography.Text>
                                                <Form.Item
                                                    name={"allowShareholderOperation"}
                                                    initialValue={allowShareholderOperation}
                                                    valuePropName="checked"
                                                >
                                                    <SwitchLabel onChange={(value) => setAllowShareholderOperation(value)} label="" />
                                                </Form.Item>
                                            </Flex >

                                        </React.Fragment>
                                    }
                                </Spin>
                            </Card>

                            {!compact &&
                                <React.Fragment>
                                    <Card title="Segmentações">
                                        <Spin spinning={loading}>
                                            {benefits.map((benefit, index) => (
                                                <Flex key={index} justify="space-between" align="center" style={{ marginBottom: 12 }}>
                                                    <Flex align="center" gap={8}>
                                                        <BoxColor color={benefit.color} />
                                                        <Typography.Text strong style={{ fontSize: '14px' }}>
                                                            {benefit.name}
                                                        </Typography.Text>
                                                    </Flex>
                                                    <SwitchLabel
                                                        checked={!!benefit.enabled}
                                                        onChange={(value) => handleBenefit(index, value)}
                                                        label=""
                                                    />
                                                </Flex>
                                            ))}
                                        </Spin>
                                    </Card>
                                </React.Fragment>
                            }

                            {!compact &&
                                <React.Fragment>
                                    <Card title="Boleto">
                                        <Spin spinning={loading}>
                                            <Flex justify="space-between">
                                                <Typography.Text
                                                    strong
                                                    style={{
                                                        fontSize: '14px'
                                                    }}>
                                                    Contas de Consumo
                                                </Typography.Text>
                                                <Form.Item
                                                    name={"acceptBillUtility"}
                                                    initialValue={acceptBillUtility}
                                                    valuePropName="checked"
                                                >
                                                    <SwitchLabel onChange={(value) => setAcceptBillUtility(value)} label="" />
                                                </Form.Item>
                                            </Flex>

                                            <Row gutter={24}>
                                                {
                                                    acceptBillUtility && <Col>
                                                        <Form.Item
                                                            label="Valor máximo diário de Boleto de Consumo permitido por usuário"
                                                            initialValue={DEFAULT_TRANSFER_LIMIT}
                                                            name="dailyBillUtilityPaymentLimit"
                                                            rules={[
                                                                { min: 0, type: 'number', message: 'Valor deve ser maior ou igual a R$ 0,00' },
                                                                { max: MAX_BILL_UTILITY_LIMIT, type: 'number', message: `Valor não deve ultrapassar R$ ${formatCurrency(MAX_BILL_UTILITY_LIMIT)}` },
                                                            ]}
                                                        >
                                                            <InputCurrency autoComplete="off" />
                                                        </Form.Item>
                                                    </Col>
                                                }
                                            </Row>

                                            <Flex justify="space-between">
                                                <Typography.Text
                                                    strong
                                                    style={{
                                                        fontSize: '14px'
                                                    }}>
                                                    Contas Genéricas
                                                </Typography.Text>
                                                <Form.Item
                                                    name={"acceptBillGeneric"}
                                                    initialValue={acceptBillGeneric}
                                                    valuePropName="checked"
                                                >
                                                    <SwitchLabel onChange={(value) => setAcceptBillGeneric(value)} label="" />
                                                </Form.Item>

                                            </Flex>

                                            <Row gutter={24}>
                                                {
                                                    acceptBillGeneric && <Col>
                                                        <Form.Item
                                                            label="Valor máximo diário de Boleto Genérico permitido por usuário"
                                                            initialValue={DEFAULT_TRANSFER_LIMIT}
                                                            name="dailyBillGenericPaymentLimit"
                                                            rules={[
                                                                { min: 0, type: 'number', message: 'Valor deve ser maior ou igual a R$ 0,00' },
                                                                { max: MAX_BILL_GENERIC_LIMIT, type: 'number', message: `Valor não deve ultrapassar R$ ${formatCurrency(MAX_BILL_GENERIC_LIMIT)}` },
                                                            ]}
                                                        >
                                                            <InputCurrency autoComplete="off" />
                                                        </Form.Item>
                                                    </Col>
                                                }
                                            </Row>

                                        </Spin>
                                    </Card>
                                </React.Fragment>
                            }

                            {!compact &&
                                <React.Fragment>
                                    <Card title="Configurações do App">
                                        <Spin spinning={loading}>
                                            <Flex justify="space-between">
                                                <Typography.Text
                                                    strong
                                                    style={{
                                                        fontSize: '16px'
                                                    }}>
                                                    App principal (AlyPlus)
                                                </Typography.Text>
                                                <Form.Item
                                                    name={"appMain"}
                                                    initialValue={appMain}
                                                    valuePropName="checked"
                                                >
                                                    <SwitchLabel onChange={(value) => handleAppMainChange(value)} label="" />
                                                </Form.Item>
                                            </Flex >

                                            <Flex justify="space-between">
                                                <Typography.Text
                                                    strong
                                                    style={{
                                                        fontSize: '16px'
                                                    }}>
                                                    Whitelabel
                                                </Typography.Text>
                                                <Form.Item
                                                    name={"whitelabel"}
                                                    initialValue={whitelabel}
                                                    valuePropName="checked"
                                                >
                                                    <SwitchLabel onChange={(value) => setWhitelabel(value)} label="" />
                                                </Form.Item>
                                            </Flex >
                                            <Flex justify="space-between">
                                                <Typography.Text
                                                    strong
                                                    style={{
                                                        fontSize: '16px'
                                                    }}>
                                                    Marketplace
                                                </Typography.Text>
                                                <Form.Item
                                                    name={"marketplace"}
                                                    initialValue={marketplace}
                                                    valuePropName="checked"
                                                >
                                                    <SwitchLabel onChange={(value) => setMarketplace(value)} label="" />
                                                </Form.Item>
                                            </Flex >

                                        </Spin>
                                    </Card>

                                    {login.company.master && (
                                        <Card>
                                            <Spin spinning={loading}>
                                                <Flex justify="space-between" style={{ marginBottom: corporateCard ? 8 : 0 }}>
                                                    <Typography.Text strong style={{ fontSize: '16px' }}>Cartão Corporativo (Corpway)</Typography.Text>
                                                    <Form.Item
                                                        name={"corporateCard"}
                                                        initialValue={corporateCard}
                                                        valuePropName="checked"
                                                    >
                                                        <SwitchLabel onChange={(value) => setCorporateCard(value)} label="" />
                                                    </Form.Item>
                                                </Flex>
                                                {corporateCard && (
                                                    <>
                                                        <Flex justify="space-between" style={{ marginBottom: 8 }}>
                                                            <Typography.Text strong style={{ fontSize: '16px' }}>Funds In via APP (Corporativo)</Typography.Text>
                                                            <Form.Item
                                                                name={"corporateFundsIn"}
                                                                initialValue={corporateFundsIn}
                                                                valuePropName="checked"
                                                            >
                                                                <SwitchLabel onChange={(value) => setCorporateFundsIn(value)} label="" />
                                                            </Form.Item>
                                                        </Flex>
                                                        <Flex justify="space-between" style={{ marginBottom: 8 }}>
                                                            <Typography.Text strong style={{ fontSize: '16px' }}>PIX Corporativo</Typography.Text>
                                                            <Form.Item
                                                                name={"corporatePix"}
                                                                initialValue={corporatePix}
                                                                valuePropName="checked"
                                                            >
                                                                <SwitchLabel onChange={(value) => setCorporatePix(value)} label="" />
                                                            </Form.Item>
                                                        </Flex>
                                                        <Flex justify="space-between" style={{ marginBottom: 8 }}>
                                                            <Typography.Text strong style={{ fontSize: '16px' }}>TED Corporativo</Typography.Text>
                                                            <Form.Item
                                                                name={"corporateTed"}
                                                                initialValue={corporateTed}
                                                                valuePropName="checked"
                                                            >
                                                                <SwitchLabel onChange={(value) => setCorporateTed(value)} label="" />
                                                            </Form.Item>
                                                        </Flex>
                                                        <Flex justify="space-between" style={{ marginBottom: acceptCorporateBill ? 8 : 0 }}>
                                                            <Typography.Text strong style={{ fontSize: '16px' }}>Contas de Consumo (Corporativo)</Typography.Text>
                                                            <Form.Item
                                                                name={"acceptCorporateBill"}
                                                                initialValue={acceptCorporateBill}
                                                                valuePropName="checked"
                                                            >
                                                                <SwitchLabel onChange={(value) => setAcceptCorporateBill(value)} label="" />
                                                            </Form.Item>
                                                        </Flex>
                                                        {acceptCorporateBill && (
                                                            <Row gutter={24}>
                                                                <Col>
                                                                    <Form.Item
                                                                        label="Valor máximo diário de Boleto de Consumo Corporativo por usuário"
                                                                        name="corporateDailyBillPaymentLimit"
                                                                        initialValue={corporateDailyBillPaymentLimit}
                                                                        rules={[
                                                                            { min: 0, type: 'number', message: 'Valor deve ser maior ou igual a R$ 0,00' },
                                                                            { max: MAX_BILL_UTILITY_LIMIT, type: 'number', message: `Valor não deve ultrapassar R$ ${formatCurrency(MAX_BILL_UTILITY_LIMIT)}` },
                                                                        ]}
                                                                    >
                                                                        <InputCurrency autoComplete="off" />
                                                                    </Form.Item>
                                                                </Col>
                                                            </Row>
                                                        )}
                                                        <Flex justify="space-between" style={{ marginBottom: acceptCorporateBillGeneric ? 8 : 0 }}>
                                                            <Typography.Text strong style={{ fontSize: '16px' }}>Contas Genéricas (Corporativo)</Typography.Text>
                                                            <Form.Item
                                                                name={"acceptCorporateBillGeneric"}
                                                                initialValue={acceptCorporateBillGeneric}
                                                                valuePropName="checked"
                                                            >
                                                                <SwitchLabel onChange={(value) => setAcceptCorporateBillGeneric(value)} label="" />
                                                            </Form.Item>
                                                        </Flex>
                                                        {acceptCorporateBillGeneric && (
                                                            <Row gutter={24}>
                                                                <Col>
                                                                    <Form.Item
                                                                        label="Valor máximo diário de Boleto Genérico Corporativo por usuário"
                                                                        name="corporateDailyBillGenericPaymentLimit"
                                                                        initialValue={corporateDailyBillGenericPaymentLimit}
                                                                        rules={[
                                                                            { min: 0, type: 'number', message: 'Valor deve ser maior ou igual a R$ 0,00' },
                                                                            { max: MAX_BILL_GENERIC_LIMIT, type: 'number', message: `Valor não deve ultrapassar R$ ${formatCurrency(MAX_BILL_GENERIC_LIMIT)}` },
                                                                        ]}
                                                                    >
                                                                        <InputCurrency autoComplete="off" />
                                                                    </Form.Item>
                                                                </Col>
                                                            </Row>
                                                        )}
                                                        <Typography.Text strong style={{ fontSize: '16px', display: 'block', marginTop: 16, marginBottom: 12 }}>
                                                            Taxas
                                                        </Typography.Text>
                                                        <Row gutter={24}>
                                                            <Col lg={12} sm={24}>
                                                                <Form.Item label="Taxa PIX Corporativo" name="corporatePixFee" initialValue={corporatePixFee}>
                                                                    <InputCurrency autoComplete="off" onChange={setCorporatePixFee} />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col lg={12} sm={24}>
                                                                <Form.Item label="Taxa TED Corporativo" name="corporateTedFee" initialValue={corporateTedFee}>
                                                                    <InputCurrency autoComplete="off" onChange={setCorporateTedFee} />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col lg={12} sm={24}>
                                                                <Form.Item label="Taxa Boleto Consumo" name="corporateBillFeeUtility" initialValue={corporateBillFeeUtility}>
                                                                    <InputCurrency autoComplete="off" onChange={setCorporateBillFeeUtility} />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col lg={12} sm={24}>
                                                                <Form.Item label="Taxa Boleto Genérico" name="corporateBillFeeGeneric" initialValue={corporateBillFeeGeneric}>
                                                                    <InputCurrency autoComplete="off" onChange={setCorporateBillFeeGeneric} />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col lg={12} sm={24}>
                                                                <Form.Item label="Taxa de Carga (%)" name="corporateChargeFee" initialValue={corporateChargeFee}>
                                                                    <InputCurrency autoComplete="off" onChange={setCorporateChargeFee} />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col lg={12} sm={24}>
                                                                <Form.Item label="Taxa por Participante" name="corporatePartChargeFee" initialValue={corporatePartChargeFee}>
                                                                    <InputCurrency autoComplete="off" onChange={setCorporatePartChargeFee} />
                                                                </Form.Item>
                                                            </Col>
                                                        </Row>
                                                        <Typography.Text strong style={{ fontSize: '16px', display: 'block', marginTop: 16, marginBottom: 12 }}>
                                                            Limites PIX Corporativo
                                                        </Typography.Text>
                                                        <Form.Item
                                                            label={
                                                                <span>
                                                                    Valor máximo diário de PIX corporativo por usuário{' '}
                                                                    <Tooltip title="Limite interno da Aly+. Define o valor máximo acumulado que um usuário pode transferir via PIX corporativo durante o dia inteiro, independentemente do horário. Não tem delay de 24h — alterações valem imediatamente. Este é o valor exibido para o usuário no app como 'Limite disponível agora'.">
                                                                        <InfoCircleOutlined />
                                                                    </Tooltip>
                                                                </span>
                                                            }
                                                            name="corporateDailyPixLimit"
                                                            initialValue={corporateDailyPixLimit}
                                                        >
                                                            <InputCurrency autoComplete="off" onChange={setCorporateDailyPixLimit} />
                                                        </Form.Item>
                                                        <Row gutter={24}>
                                                            <Col lg={12} sm={24}>
                                                                <Form.Item label={<span>Limite diurno (das 06:00 às 19:59)&nbsp;<Tooltip title="Limite regulatório do Banco Central para transferências PIX realizadas no período diurno (das 06h00 às 19h59). Alterações são propagadas para todos os usuários da empresa em até 24 horas."><InfoCircleOutlined style={{ marginLeft: 5}} /></Tooltip></span>} name="corporatePixDayLimit" initialValue={corporatePixDayLimit}>
                                                                    <InputCurrency autoComplete="off" onChange={setCorporatePixDayLimit} />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col lg={12} sm={24}>
                                                                <Form.Item label={<span>Limite noturno (das 20:00 às 05:59)&nbsp;<Tooltip title="Limite regulatório do Banco Central para transferências PIX realizadas no período noturno (das 20h00 às 05h59). Alterações são propagadas para todos os usuários da empresa em até 24 horas."><InfoCircleOutlined style={{ marginLeft: 5}} /></Tooltip></span>} name="corporatePixNightLimit" initialValue={corporatePixNightLimit}>
                                                                    <InputCurrency autoComplete="off" onChange={setCorporatePixNightLimit} />
                                                                </Form.Item>
                                                            </Col>
                                                        </Row>
                                                    </>
                                                )}
                                            </Spin>
                                        </Card>
                                    )}
                                </React.Fragment>
                            }

                            {!compact &&
                                <React.Fragment>
                                    <Card title="Pix em Lote">
                                        <Spin spinning={loading}>
                                            <Row gutter={24}>
                                                <Col lg={12} sm={24}>
                                                    <Form.Item
                                                        label="Limite diurno"
                                                        name="pixCompanyDayLimit"
                                                        initialValue={DEFAULT_PIX_COMPANY_DAY_LIMIT}
                                                    >
                                                        <InputCurrency autoComplete="off" onChange={setPixCompanyDayLimit} />
                                                    </Form.Item>
                                                </Col>
                                                <Col lg={12} sm={24}>
                                                    <Form.Item
                                                        label="Limite noturno"
                                                        name="pixCompanyNightLimit"
                                                        initialValue={DEFAULT_PIX_COMPANY_NIGHT_LIMIT}
                                                    >
                                                        <InputCurrency autoComplete="off" onChange={setPixCompanyNightLimit} />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </Spin>
                                    </Card>

                                    <Card title="Agendamentos">
                                        <Spin spinning={loading}>
                                            <Row gutter={24}>
                                                <Col lg={24} sm={24}>
                                                    <Flex justify="space-between">
                                                        <Typography.Text
                                                            strong
                                                            style={{
                                                                fontSize: '16px'
                                                            }}>
                                                            Habilitar agendamentos
                                                        </Typography.Text>
                                                        <Form.Item
                                                            name={"schedule"}
                                                            initialValue={schedule}
                                                            valuePropName="checked"
                                                        >
                                                            <SwitchLabel onChange={(value) => setSchedule(value)} label="" />
                                                        </Form.Item>
                                                    </Flex >
                                                </Col>
                                            </Row>
                                            {schedule && <Row gutter={24}>
                                                <Col lg={12} sm={24}>
                                                    <Form.Item
                                                        label="Limite minimo por agendamento"
                                                        name="minScheduleValue"
                                                        initialValue={DEFAULT_SCHEDULE_COMPANY_MIN_LIMIT}
                                                    >
                                                        <InputCurrency autoComplete="off" onChange={setMinScheduleValue} />
                                                    </Form.Item>
                                                </Col>
                                                <Col lg={12} sm={24}>
                                                    <Form.Item
                                                        label="Limite maximo por agendamento"
                                                        name="maxScheduleValue"
                                                        initialValue={DEFAULT_SCHEDULE_COMPANY_MAX_LIMIT}
                                                    >
                                                        <InputCurrency autoComplete="off" onChange={setMaxScheduleValue} />
                                                    </Form.Item>
                                                </Col>
                                            </Row>}
                                        </Spin>
                                    </Card>

                                    <Card title="Cartão">
                                        <Spin spinning={loading}>
                                            <Row gutter={24}>
                                                <Col lg={12} sm={24}>
                                                    <Form.Item
                                                        label="Custo por cartão"
                                                        name="cardCost"
                                                    >
                                                        <InputCurrency autoComplete="off" />
                                                    </Form.Item>
                                                </Col>
                                                <Col lg={12} sm={24}>
                                                    <Form.Item
                                                        label="Custo por entrega individual"
                                                        name="deliveryCost"
                                                    >
                                                        <InputCurrency autoComplete="off" />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </Spin>
                                    </Card>
                                    <Card title="Reembolso Corporativo">
                                        <Spin spinning={loading}>
                                            <Row gutter={24}>
                                                <Col lg={12} sm={24}>
                                                    <Form.Item
                                                        label="Custo por reembolso corporativo"
                                                        name="refundCost"
                                                    >
                                                        <InputCurrency autoComplete="off" />
                                                    </Form.Item>
                                                </Col>
                                                <Col lg={12} sm={24}>
                                                    <Form.Item
                                                        label="Custo por boleto"
                                                        name="refundBillCost"
                                                    >
                                                        <InputCurrency autoComplete="off" />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </Spin>
                                    </Card>
                                </React.Fragment>
                            }

                            {!compact &&
                                <React.Fragment>
                                    <Card title="Contrato">
                                        <Spin spinning={loading}>
                                            <Row gutter={24}>
                                                <Col lg={12} sm={24}>
                                                    <Form.Item
                                                        label="Parceiro"
                                                        name={["partnership", "id"]}>
                                                        <AutoCompleteCompany />
                                                    </Form.Item>
                                                </Col>
                                                <Col lg={12} sm={24}>
                                                    <Form.Item
                                                        label="Primeiro Contrato"
                                                        name="firstContractAt"
                                                        rules={[{ required: false }]}
                                                    >
                                                        <DatePicker style={{ width: "100%" }} format={(v) => moment(v).format('DD/MM/YYYY')} />
                                                    </Form.Item>
                                                </Col>
                                                <Col lg={12} sm={24}>
                                                    <Form.Item
                                                        label="Taxa por Saque Pessoal"
                                                        name="refundFee"
                                                        initialValue={9.90}
                                                    >
                                                        <InputCurrency autoComplete="off" />
                                                    </Form.Item>
                                                </Col>
                                                <Col lg={12} sm={24}>
                                                    <Form.Item
                                                        label="Taxa por Participante"
                                                        name="employeeFee"
                                                        initialValue={0}
                                                    >
                                                        <InputCurrency autoComplete="off" />
                                                    </Form.Item>
                                                </Col>
                                                <Col lg={12} sm={24}>
                                                    <Form.Item
                                                        label="Taxa de Inatividade"
                                                        name="inactiveFee"
                                                        initialValue={3}
                                                    >
                                                        <InputCurrency autoComplete="off" />
                                                    </Form.Item>
                                                </Col>
                                                <Col lg={12} sm={24}>
                                                    <Form.Item
                                                        label="Taxa Nota Fiscal"
                                                        name="taxInvoice"
                                                        initialValue={0}
                                                    >
                                                        <InputCurrency autoComplete="off" />
                                                    </Form.Item>
                                                </Col>
                                                <Col lg={12} sm={24}>
                                                    <Form.Item
                                                        label="Taxa de Transferência TED"
                                                        name="tedTransferFee"
                                                        initialValue={9.90}
                                                    >
                                                        <InputCurrency autoComplete="off" />
                                                    </Form.Item>
                                                </Col>
                                                <Col lg={12} sm={24}>
                                                    <Form.Item
                                                        label="Taxa de Transferência PIX"
                                                        name="pixTransferFee"
                                                        initialValue={7.90}
                                                    >
                                                        <InputCurrency autoComplete="off" />
                                                    </Form.Item>
                                                </Col>
                                                <Col lg={12} sm={24}>
                                                    <Form.Item
                                                        label="Taxa de Carga Administrativa - Livre"
                                                        name="chargeFee"
                                                        initialValue={2}
                                                        rules={[
                                                            { type: 'number', max: 100, message: 'O valor máximo é 100' },
                                                        ]}
                                                    >
                                                        <InputCurrency min={0} addonBefore="%" autoComplete="off" />
                                                    </Form.Item>
                                                </Col>
                                                <Col lg={12} sm={24}>
                                                    <Form.Item
                                                        label="Taxa Mensal"
                                                        name="monthFee"
                                                    >
                                                        <InputCurrency autoComplete="off" />
                                                    </Form.Item>
                                                </Col>
                                                <Col lg={12} sm={24}>
                                                    <Form.Item
                                                        label="Taxa Boleto de Consumo"
                                                        name="billFeeUtility"
                                                        initialValue={1.90}
                                                    >
                                                        <InputCurrency autoComplete="off" />
                                                    </Form.Item>
                                                </Col>
                                                <Col lg={12} sm={24}>
                                                    <Form.Item
                                                        label="Taxa Boleto Genérico"
                                                        name="billFeeGeneric"
                                                        initialValue={7.90}
                                                    >
                                                        <InputCurrency autoComplete="off" />
                                                    </Form.Item>
                                                </Col>
                                                <Col lg={12} sm={24}>
                                                    <Form.Item
                                                        label="Taxa de Carga por Usuário"
                                                        name="partChargeFee"
                                                    >
                                                        <InputCurrency autoComplete="off" />
                                                    </Form.Item>
                                                </Col>
                                                <Col lg={12} sm={24}>
                                                    <Form.Item
                                                        label="Taxa de descarga - Breakage"
                                                        name="dischargeFee"
                                                        initialValue={2}
                                                        rules={[
                                                            { type: 'number', max: 100, message: 'O valor máximo é 100' },
                                                        ]}
                                                    >
                                                        <InputCurrency min={0} addonBefore="%" autoComplete="off" />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </Spin>
                                    </Card>
                                    <Card title="Cartão">
                                        <Spin spinning={loading}>
                                            <Row gutter={24}>
                                                <Col lg={12} sm={24}>
                                                    <Form.Item
                                                        label="Custo por cartão"
                                                        name="cardCost"
                                                    >
                                                        <InputCurrency autoComplete="off" />
                                                    </Form.Item>
                                                </Col>
                                                <Col lg={12} sm={24}>
                                                    <Form.Item
                                                        label="Custo por entrega individual"
                                                        name="deliveryCost"
                                                    >
                                                        <InputCurrency autoComplete="off" />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </Spin>
                                    </Card>
                                    <Card title="Reembolso Corporativo">
                                        <Spin spinning={loading}>
                                            <Row gutter={24}>
                                                <Col lg={12} sm={24}>
                                                    <Form.Item
                                                        label="Custo por reembolso corporativo"
                                                        name="refundCost"
                                                    >
                                                        <InputCurrency autoComplete="off" />
                                                    </Form.Item>
                                                </Col>
                                                <Col lg={12} sm={24}>
                                                    <Form.Item
                                                        label="Custo por boleto"
                                                        name="refundBillCost"
                                                    >
                                                        <InputCurrency autoComplete="off" />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </Spin>
                                    </Card>
                                </React.Fragment>
                            }
                            <FormAddress loading={loading} form={form} required={true} country={true} />
                        </Space>
                    </Form>
                </Col>
            </Row>
        </>
    )

    if (compact) {
        return (ContentForm)
    } else {
        return (
            <Layout className="alymente-layout">
                <Header title={`${data && data.name ? data.name : ""}`} routes={loadSubRoutes} />
                <Content>
                    {ContentForm}
                    <Row justify="center" align={'middle'} style={{ marginTop: 30 }}>
                        <Col xl={20} lg={22} md={24}>
                            <CompanyShareholderScreen loading={loading} company={id} formCompany={form} />
                        </Col>
                    </Row>
                </Content>
                <Footer style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'space-between',
                }}>
                    <Button
                        disabled={loading}
                        loading={loading}
                        className="btn-save"
                        type="primary"
                        onClick={() => navigate(`/company`)}>Voltar</Button>
                    <Button
                        disabled={loading}
                        loading={loading}
                        className="btn-save"
                        type="primary"
                        icon={<SaveOutlined />}
                        onClick={() => form.submit()}>Salvar</Button>
                </Footer>
            </Layout >
        )
    }
});

export default connect(mapStateToProps, null, null, { forwardRef: true })(CompanyDetailsScreen);
